import IframeMessagePublisher from './iframeMessagePublisher';

export const postMessage = (message, params) => {
  IframeMessagePublisher.postMessage(message, params);
};
